import * as Icons from "lucide-react";
import { DIGITAL } from "../../data/site";
import { Reveal } from "../motion";
import { SectionHead } from "../SectionHead";
import { CtaButton } from "../Buttons";

export const DigitalMarketing = () => (
  <section data-testid="digital-section" className="grain relative overflow-hidden bg-[color:var(--ngp-ink)] text-white">
    <div aria-hidden="true" className="pointer-events-none absolute -right-24 top-10 select-none font-display text-[28vw] font-semibold leading-none text-white/[0.03]">2021</div>
    <div className="relative mx-auto max-w-[1440px] px-5 py-24 sm:px-8 lg:px-12 lg:py-36">
      <SectionHead dark index="03" eyebrow="Digital Marketing · dal 2021" lines={["La tua immagine,", "anche online."]}
        text="Il nostro team di Marketing e Comunicazione porta sul digitale la stessa cura che mettiamo in produzione." />
      <div className="mt-14 grid gap-px overflow-hidden rounded-[var(--ngp-radius)] bg-white/10 md:grid-cols-3 lg:mt-20">
        {DIGITAL.map((d, i) => {
          const Icon = Icons[d.icon] || Icons.Globe;
          return (
            <Reveal key={d.title} delay={i * 0.1} className="group relative bg-[color:var(--ngp-ink)] p-8 transition-colors duration-500 hover:bg-[color:var(--ngp-graphite)] lg:p-10">
              <div data-testid={`digital-card-${i + 1}`}>
                <div className="flex items-center justify-between">
                  <Icon size={30} strokeWidth={1.3} className="text-[color:var(--ngp-teal)]" aria-hidden="true" />
                  <span className="font-display text-sm text-white/60">0{i + 1}</span>
                </div>
                <h3 className="font-display mt-16 text-2xl font-semibold sm:text-3xl">{d.title}</h3>
                <p className="mt-3 text-base leading-relaxed text-white/75">{d.text}</p>
                <span className="absolute inset-x-0 bottom-0 h-[3px] origin-left scale-x-0 bg-[color:var(--ngp-teal)] transition-transform duration-700 group-hover:scale-x-100" />
              </div>
            </Reveal>
          );
        })}
      </div>
      <Reveal className="mt-12"><CtaButton to="/marketing" testId="digital-more-btn">Scopri il Digital Marketing</CtaButton></Reveal>
    </div>
  </section>
);
